angular.module('bribac.views.listSubjects', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.entities.subjectFactory',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'bribac.components.subjectDetails'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/subject', {
      templateUrl: 'list-subjects-view.html',
      controller: 'ListSubjectsViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('ListSubjectsViewCtrl', function(
    KINDS,
    subjectFactory,
    api
  ) {
    var $ctrl = this

    $ctrl.subjectsPromise = api.getView(KINDS.SUBJECT).then(function(request) {
      $ctrl.subjects = request.data.list
    })
  })
